import Request from "../../../../../api/Requests";

const getEventGuestlistStatsEntries = (params) => {
  return Request("events/guestlist-stats-entries", "GET", params, true);
};

export default {
  getEventGuestlistStatsEntries,
};
